/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as LexiconSchema from './schema.defs.js'

const $nsid = 'com.atproto.lexicon.resolveLexicon'

export { $nsid }

/** Resolves an atproto lexicon (NSID) to a schema. */
const main = l.query(
  $nsid,
  l.params({ nsid: l.string({ format: 'nsid' }) }),
  l.jsonPayload({
    cid: l.string({ format: 'cid' }),
    schema: l.ref<LexiconSchema.Main>((() => LexiconSchema.main) as any),
    uri: l.string({ format: 'at-uri' }),
  }),
  ['LexiconNotFound'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
